import { NOTIFY_ADD_TO_CART } from '@dustin-web/microsite-data/src/graphql/product/notify-add-to-cart.graphql'
import { useGraphqlMutation } from '@dustin-web/microsite-data/src/hooks'
import {
  NotifyAddToCartMutation,
  NotifyAddToCartMutationVariables,
} from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'

export type UseNotifyAddToCart = typeof useNotifyCart
export function useNotifyCart() {
  const [notifyAddToCart] = useGraphqlMutation<
    NotifyAddToCartMutation,
    NotifyAddToCartMutationVariables
  >(NOTIFY_ADD_TO_CART)

  return (ticket: string) => notifyAddToCart({ variables: { ticket } })
}
